export const SET_USER_STATE = 'user/SET_USER_STATE'
export const SET_USER_STATE_FULL = 'user/SET_USER_STATE_FULL'
export const SIGN_OUT = 'user/SIGN_OUT'
